import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { ButtonStyleReset } from '../button/button.js';
import { Text } from '../text/text.js';
import { colors, colorScale } from '../../tokens/colors/colors.js';
import '../../tokens/shadows/shadows.js';
import { spacing } from '../../tokens/spacing/spacing.js';
import '../../tokens/breakpoints/breakpoints.js';

function _Chip({ label, Icon, onClick, active, size = "medium", borderType = "solid", }, ref) {
    return (jsxs(ChipWrapper, { onClick: onClick, "$borderType": borderType, "$size": size, "$active": !!active, ref: ref, children: [jsx(Icon, { width: 9 }), jsx(Text, { variant: "bodyS", children: label })] }));
}
const Chip = forwardRef(_Chip);
const ChipWrapper = styled.button `
  ${ButtonStyleReset}

  display:inline-flex;
  align-items: center;
  gap: ${spacing.XS};
  padding-inline: ${spacing.XS2};
  padding-block: ${({ $size }) => ($size === "small" ? 0 : spacing.XS3)};
  background-color: ${colors.neutralLight};
  border-radius: 50px;
  border-width: 1px;
  border-style: ${({ $borderType, $active }) => $borderType === "dashed" && !$active ? "dashed" : "solid"};
  border-color: ${({ $active }) => $active ? colors.systemInfo : colors.divider};
  white-space: nowrap;

  transition: background-color 0.2s;

  &:hover,
  &:focus-visible {
    background-color: ${colors.neutral};
    border-style: solid;
  }

  &:focus-visible {
    border-color: ${colorScale.koti[600]};
  }
`;

export { Chip };
